<script setup lang="ts">
import type { DogtagComponentType } from '@/types/gloss';

import type { DogTagComponent } from '../model';

const { components } = defineProps<{
  components: Record<DogtagComponentType, DogTagComponent>;
}>();

const element = components.patch || components.emblem;

const style = ref({});
const img = element.icons?.medium as string | undefined;
if (img) {
  style.value = { backgroundImage: `url(https:${img})` };
}
</script>

<template>
  <div
    class="emblem"
    :style="style"
  />
</template>

<style scoped lang="postcss">
.emblem {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
